import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./rentalhouse.css";
import API from "../../../../api";
import { Phone, MessageCircle, Mail } from "lucide-react";

export default function RentHouse() {
  const navigate = useNavigate();

  const [houses, setHouses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showConsult, setShowConsult] = useState(false);
const [consultUser, setConsultUser] = useState(null);

  /* Filters */
  const [search, setSearch] = useState("");
  const [location, setLocation] = useState("");
  const [minRent, setMinRent] = useState("");
  const [maxRent, setMaxRent] = useState("");

  const user = JSON.parse(localStorage.getItem("civilink_user"));

  /* ================================
     FETCH RENT HOUSES
  ================================= */
  const fetchRentHouses = async () => {
    setLoading(true);

    const params = new URLSearchParams();
    if (search) params.append("q", search);
    if (location) params.append("location", location);
    if (minRent) params.append("minRent", minRent);
    if (maxRent) params.append("maxRent", maxRent);

    try {
      const res = await fetch(
        `/api/rent/list?${params.toString()}`
      );
      const data = await res.json();

      if (data.success) {
        setHouses(data.rentHouses);
      } else {
        setHouses([]);
      }
    } catch {
      setHouses([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRentHouses();
  }, []);

  /* ================================
     CONTACT OWNER (CHAT)
  ================================= */
const contactOwner = (owner) => {
  if (!localStorage.getItem("token")) {
    navigate("/");
    return;
  }

  setConsultUser(owner);
  setShowConsult(true);
};



  /* ================================
     RESET FILTERS
  ================================= */
  const resetFilters = () => {
    setSearch("");
    setLocation("");
    setMinRent("");
    setMaxRent("");
    fetchRentHouses();
  };
  
 

  return (
    <div className="rent-page">
      {/* ================= FILTER BAR ================= */}
      <div className="rent-filters">
        <input
          placeholder="Search house or area"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <input
          placeholder="Location"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
        />

        <input
          type="number"
          placeholder="Min ₹ / month"
          value={minRent}
          onChange={(e) => setMinRent(e.target.value)}
        />

        <input
          type="number"
          placeholder="Max ₹ / month"
          value={maxRent}
          onChange={(e) => setMaxRent(e.target.value)}
        />

        <button className="rent-apply-btn" onClick={fetchRentHouses}>
          Apply
        </button>

        <button className="rent-reset-btn" onClick={resetFilters}>
          Reset
        </button>
      </div>

      {/* ================= CONTENT ================= */}
      {loading ? (
        <div className="rent-loading">Loading rentals…</div>
      ) : houses.length === 0 ? (
        <div className="rent-empty">
          No rental houses found
        </div>
      ) : (
        <div className="rent-list">
  {houses.map((h) => {
    const ownerId =
      typeof h.postedBy === "object"
        ? h.postedBy?._id
        : h.postedBy;

    return (
      <div key={h._id} className="rent-card">
        {h.imageUrl && (
          <img
            src={h.imageUrl}
            alt="Rent House"
            className="rent-image"
          />
        )}

        <div className="rent-info">
          <h4>{h.title}</h4>

          <p className="rent-location">
            📍 {h.location?.city}, {h.location?.state}
          </p>

          <p className="rent-price">
            ₹{Number(h.rent).toLocaleString("en-IN")} / month
          </p>

          {h.deposit > 0 && (
            <p className="rent-deposit">
              Deposit: ₹{Number(h.deposit).toLocaleString("en-IN")}
            </p>
          )}

          {h.availableFrom && (
            <p className="rent-date">
              Available from:{" "}
              {new Date(h.availableFrom).toLocaleDateString()}
            </p>
          )}
        </div>

        {user && ownerId ? (
          ownerId === user._id ? (
            <button className="rent-own-btn" disabled>
              Your Listing
            </button>
          ) : (
            <button
              className="rent-contact-btn"
              onClick={() => contactOwner(h.postedBy)}
            >
              Contact Owner
            </button>
          )
        ) : (
          <button className="rent-contact-btn" disabled>
            Owner unavailable
          </button>
        )}
      </div>
    );
  })}
</div>

          
      )}
      {showConsult && (
        <div
          className="customer-sheet-overlay"
          onClick={() => setShowConsult(false)}
        >
          <div
            className="customer-sheet"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="sheet-handle" />
      
            <h3 className="sheet-title">
              Contact Professional
            </h3>
      
            <p className="sheet-subtitle">
              Choose how you'd like to connect.
            </p>
      
            {consultUser?.phone && (
              <>
                <button
                  className="sheet-btn primary"
                  onClick={() => {
                    window.location.href = `tel:${consultUser.phone}`;
                    setShowConsult(false);
                  }}
                >
                  <Phone size={18} />
                  <span>Call</span>
                </button>
      
                <button
                  className="sheet-btn primary"
                  onClick={() => {
                    const text = encodeURIComponent(
                      `Hello ${consultUser.name},
      
      I found your profile on Civilink and would like to discuss my construction requirements.`
                    );
      
                    window.open(
                      `https://wa.me/91${consultUser.phone}?text=${text}`,
                      "_blank"
                    );
      
                    setShowConsult(false);
                  }}
                >
                  <MessageCircle size={18} />
                  <span>WhatsApp</span>
                </button>
              </>
            )}
      
            {consultUser?.email && (
              <button
                className="sheet-btn primary"
                onClick={() => {
                  window.location.href = `mailto:${consultUser.email}?subject=Construction Inquiry from Civilink`;
                  setShowConsult(false);
                }}
              >
                <Mail size={18} />
                <span>Email</span>
              </button>
            )}
      
            {!consultUser?.phone && !consultUser?.email && (
              <div className="contact-unavailable">
                Contact information not available.
              </div>
            )}
      
            <button
              className="sheet-btn outline"
              onClick={() => setShowConsult(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
